import { render, staticRenderFns } from "./KusClientAccessRole.vue?vue&type=template&id=20e4199c"
import script from "./KusClientAccessRole.vue?vue&type=script&lang=js"
export * from "./KusClientAccessRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports